
/**
* src/connects/chat-message-item.js
* 
*/

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import combineHOC from '../helpers/combine-hoc'
import actions from '../actions'
import { translate } from 'react-i18next'
import context from '../helpers/context'
import filter from 'lodash/filter'
import ui from '../helpers/ui-state'
import { updateUserProfile } from '../actions/user'
import { emitAlertMessage } from '../actions/alert-message'

function isImage(file) {
  return file.content_type.match(/^image/)
}

function isPdf(file) {
  return file.content_type.match(/^application\/pdf/)
}

function isVideo(file) {
  return file.content_type.match(/^video/) && (file.status == 'committed')
}

function isAudio(file) {
  return file.content_type.match(/^audio/) && (file.status == 'committed')
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const files = ownProps.message.files && filter(ownProps.message.files, (file)=> !isImage(file) && !isVideo(file) && !isAudio(file) && !isPdf(file)).map((file)=> {
    const num = file && file.name.lastIndexOf('.')
    const basename = num != -1 && file.name.slice(0, num) || file.name
    const extension = num != -1 && file.name.slice(num + 1, file.name.length) || ''
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name
    file.showTooltip = basename.length > 10 ? true : false
    return file
  }) || []

  const images = ownProps.message.files && filter(ownProps.message.files, (file)=> isImage(file)) || []
  const videos = ownProps.message.files && filter(ownProps.message.files, (file)=> isVideo(file)) || []
  const pdfs   = ownProps.message.files && filter(ownProps.message.files, (file)=> isPdf(file)).map((file)=> {
    const num = file && file.name.lastIndexOf('.')
    const basename = num != -1 && file.name.slice(0, num) || file.name
    const extension = num != -1 && file.name.slice(num + 1, file.name.length) || ''
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name
    return file
  }) || []

  const audios = ownProps.message.files && filter(ownProps.message.files, (file)=> isAudio(file)).map((file)=> {
    const num = file && file.name.lastIndexOf('.')
    const basename = num != -1 && file.name.slice(0, num) || file.name
    const extension = num != -1 && file.name.slice(num + 1, file.name.length) || ''
    file.filename = basename.length > 10 ? basename.slice(0, 10) + '...' + extension : file.name
    file.showTooltip = basename.length > 10 ? true : false
    file.isAudio = true
    return file
  }) || []

  const isMessage = files.length == 0 && images.length == 0 && videos.length == 0 && audios.length == 0 && pdfs.length == 0

  return {
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    pdfs,
    files,
    images,
    videos,
    audios,
    isMessage,
  }
}

export const mapDispatchToProps = (dispatch)=> {
  return {
    showGoogleDoc:  (url)=> {
      dispatch(actions.openRightSidePage('google_doc', { url: url }, true))
    },
    showPdfPreview:  (file)=> {
      dispatch(actions.openRightSidePage('pdf_preview', { file: file }, true))
    },
    notChatRoomMember: ()=> dispatch(emitAlertMessage('label:対象ユーザーはこのチャットルームには参加していません。', 'error'))
  }
}

export default combineHOC(
  connect(undefined, mapDispatchToProps, mergeProps),
  ui({
    state: {
      user: undefined,
      openDialog: false,
    }
  }),
  context({ showImagesView: PropTypes.func }),
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/chat-message-item.js